import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useRef,
  RefObject,
  useState,
} from "react";

import { PassengerStatusQuestionsType } from "./PassengerStatusQuestionsType";
import StandardColors from "../../../../../../../util/StandardColors";
import UserCardComponent from "../UserCard/UserCard";
import StatusChip from "../../../../common/status-chip/StatusChip";
import StandardFonts from "../../../../../../../util/StandardFonts";
import PropertyDisplayField from "../PropertyField/PropertyDisplayField";
import { Box, List, Text } from "grommet";
import { StyleSheet } from "../../../../../../../typings/StyleSheet";
import Chip from "../../../../common/chip/Chip";
import { MedicalEmergencyStatus } from "../../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import age from "../../../../../../../assets/age.svg";
import seatNo from "../../../../../../../assets/seat-no.svg";
import gender from "../../../../../../../assets/gender.svg";
import planelanded from "../../../../../../../assets/planeLanded.png";
import editIcon from "../../../../../../../assets/edit.svg";
import planLanded from "../../../../../../../assets/flight_land.svg";
import minimize from "../../../../../../../assets/collapse_content.svg";
import emsProfile from "../../../../../../../assets/ems-profile.webp";
import minimize_hover_state from "../../../../../../../assets/collapse_content_white.svg";
import expand from "../../../../../../../assets/expand_content.svg";
import expand_hover_state from "../../../../../../../assets/expand_content white.svg";
import diversion from "../../../../../../../assets/diversion.svg";
import PropertyStatusField from "../PropertyField/PropertyStatusField";
import "./MedicalEmergencyCard.css";
import { useStore } from "../../../../../../../Hooks/useStore";
import { Observer, observer } from "mobx-react";
import { Mixpanel } from "../../../../../../../util/Helper";
import MedicalEmergencyService from "../../../../../../../services/medical-emergency/medical-emergency.service";
import { FlightService } from "../../../../../../../services/flights/flight.service";
import { useUser } from "../../../../../context/User/UserContext";
import { sendDataToTopic } from "../../../../../../../App";
import { Autoupdateenum } from "../../../../../../../enums";
import PatientConscious from "../PatientConscious/PatientConscious";
import PassengerMedicalHistory from "../PassengerMedicalHistory/PassengerMedicalHistory";
import RecommedDiversion from "../RecommedDiversion/RecommedDiversion";
import PassengerService from "../../../../../../../services/passenger/passenger.service";
import { Storage } from "aws-amplify";
import usersService from "../../../IAM/Users/users.service";
import { FaPlane } from 'react-icons/fa';  // Import the Plane icon from react-icons
import FlightLocationDemo from './../../MedicalEmergencyDetails/FlightTracker/FlightTracker';


type ActionMenuFunctionType = (ard: boolean) => React.ReactNode;
type CardHeightFunctionType = (contentHeight: number) => void;
type MedicalEmergencyCardPropType = {
  seatNumber: string;
  passengerName: string;
  gender: string;
  age: string;
  emsId: string;
  containerStyle: CSSProperties;
  symptoms: string[];
  treatmentsGiven: string[];
  passengerStatusQuestions: PassengerStatusQuestionsType[];
  footerComponent?: React.ReactNode;
  status: MedicalEmergencyStatus;
  online: boolean;
  detail: boolean;
  diversion: string;
  landed: boolean;
  time?: string;
  flightNo?: string;
  tailNo?: string;
  PatientConscious: boolean;
  actionMenu: ActionMenuFunctionType;
  cardHeight: CardHeightFunctionType;
};

const MedicalEmergencyCard: FunctionComponent<MedicalEmergencyCardPropType> =
  observer((props) => {
    const { rootStore } = useStore();
    const { user } = useUser();
    const boxRef = useRef<HTMLDivElement>(null);

    const getfullname = (emsid: string) => {
      try {
        // Fetch user data by username
        usersService
          .listUsersByUsername(emsid)
          .then((userResponse) => {
            if (userResponse.length > 0) {
              console.log("doctor full name", userResponse[0]);
              let fullname;
              if (userResponse[0]?.name || userResponse[0]?.family_name) {
                let fname = userResponse[0]?.name ?? "";
                let lname = userResponse[0]?.family_name ?? "";
                fullname = fname + lname;
              }
              rootStore.medicalCardStore.setPhysicianFName(fullname ?? emsid);
            } else {
              console.log("No user found with username:",props.emsId);
              rootStore.medicalCardStore.setPhysicianFName(emsid);
            }
          });
      } catch (error) {
        console.log("Error fetching user data:", error);
        rootStore.medicalCardStore.setPhysicianFName(emsid);
      }
    }

    useEffect(() => {
      if (props.emsId) {
        getfullname(props.emsId);
      }
    },[props.emsId]);

    const [imageSrc,setImageSrc] = useState("https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png")
    const getImage = async (filePath: string) => {
      try {
        const fileUrl = await Storage.get(filePath, {
          bucket: 'sbx-skali-report',
          region: 'us-west-1',
          level: 'public', // Adjust access level if needed
          expires: 604799
        });
    
        const response = await fetch(fileUrl);
        
        if (response.ok && response.headers.get('Content-Type')?.startsWith('image/')) {
          // If it's an image, set the image source
          const messageContent = fileUrl.split('?')[0];
          setImageSrc(fileUrl); // Only set if it's a valid image
          console.log("fileUrl",fileUrl)
          return messageContent;
        } else {
          console.error('No valid image found at the URL:', fileUrl);
          return null; // Return null or handle the case where the image does not exist
        }
      } catch (error) {
        console.error('Error fetching image:', error);
        return null; // Return null or handle the error gracefully
      }
    };
    useEffect(()=>{getImage(`profilePhotos/${props.emsId}/profile.png`)},[props.emsId])

    const SubText = () => {
      return (
        <Box style={{ display: "flex", flexDirection: "row", marginTop: 30, alignItems: 'center' }}>
          <Box className="ems-profile">
            <img src={imageSrc} alt="ems profile" />
          </Box>
          <Text
            style={{
              ...StandardFonts._body11420Medium,
              color: "#667899",
            }}
          >
            {"Assigned to"}
          </Text>
          <Text
            style={{
              ...StandardFonts._body11420Medium,
              color: "#667899",
              marginLeft: 5,
            }}
          >
            {` @ Dr. ${rootStore.medicalCardStore.getPhysicianFName}`}
          </Text>
        </Box>
      );
    };

    const [showFlightLocation, setShowFlightLocation] = useState(false);
    // Function to handle plane icon click
  const handlePlaneIconClick = () => {
    setShowFlightLocation(!showFlightLocation); // Show the FlightLocationDemo on icon click
  };

    const renderChip = (symptom: string) => {
      return (
        <Chip
          key={symptom}
          containerStyle={{ marginRight: 8, marginBottom: 8 }}
          title={symptom}
        />
      );
    };
    const renderChipList = (list: string[]) => {
      console.log("symptomlist", list);
      if (list.length === 0 || (list.length === 1 && list[0] === "")) {
        return <Box style={styles.symptomContainer}>{"Not Specified"}</Box>;
      }
      return <Box style={styles.symptomContainer}>{list.map(renderChip)}</Box>;
    };

    // Format Time
    const formatTimeStamp = (timeStamp: string | undefined) => {
      if (timeStamp !== undefined) {
        let DatenTime = timeStamp?.split("T");
        if (DatenTime) {
          let time = DatenTime[0];
          let datePart = DatenTime[1];
          let date = datePart.split("Z")[0];
          return time + " " + date;
        }
      }
    };

    const onRecommendDiversionClicked = () => {
      let uInfos = localStorage.getItem("userinfo");
      if (uInfos) {
        const userinformation = JSON.parse(uInfos);
        Mixpanel.track("web_recommend_diversion_click", {
          name: userinformation.username,
        });
      }
      rootStore.emsStore.handleDialogState({
        showConfirmation: rootStore.emsStore.getDialogState.showConfirmation,
        showLoginPrompt: true,
      });
      rootStore.medicalCardStore.setFlightStatusMenu();
    };

    const onContinueWithoutContactClicked = () => {
      let uInfos = localStorage.getItem("userinfo");
      if (uInfos) {
        const userinformation = JSON.parse(uInfos);
        Mixpanel.track("web_continue_and_monitor_click", {
          name: userinformation.username,
        });
      }
      const Url = window.location.href;
      const parts = Url.split("/");
      const emergencyId = Number(parts.at(-1));
      // MONITORING
      MedicalEmergencyService.setMedicalEmergencyStatus(
        emergencyId,
        MedicalEmergencyStatus.CONTINUE_AND_MONITOR
      )
        .then(() => {
          rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
          rootStore.medicalCardStore.setFlightStatusMenu();
          sendDataToTopic(
            rootStore.emsStore.getSelectedEmergency?.id,
            rootStore.emsStore.getSelectedEmergency?.flightId,
            Autoupdateenum.Emergency
          );
          sendDataToTopic(
            rootStore.emsStore.getSelectedEmergency?.id,
            rootStore.emsStore.getSelectedEmergency?.flightId,
            Autoupdateenum.FlightStatus
          );
        })
        .catch((e) => {
          rootStore.emsStore.handleDialogState({
            showConfirmation: false,
            showLoginPrompt: rootStore.emsStore.getDialogState.showLoginPrompt,
          });
        });
    };

    interface MenuItem {
      label: string;
      onClick: () => void;
      disabled?: boolean; // Add the disabled property
    }
    const menuItems: MenuItem[] = [
      {
        label: "Recommend Diversion",
        onClick: onRecommendDiversionClicked,
      },
      {
        label: "Continue and Monitor",
        onClick: onContinueWithoutContactClicked,
      },
    ];

    const onRecommendDispositionButtonClick = async () => {
      rootStore.loadingStore.setShowLoader(true);
      try {
        if (rootStore.emsStore.getSelectedEmergency) {
          await FlightService.updateFlightDisposition(
            rootStore.emsStore.getSelectedEmergency?.flightId
          );
          rootStore.emsStore.handlePageRefreshCount(
            rootStore.emsStore.getpageRefreshCount + 1
          );
          rootStore.medicalCardStore.setFlightStatusMenu();
        }
      } catch (e) {
        alert("Failed to recommend disposition, please check your network.");
      } finally {
        rootStore.loadingStore.setShowLoader(false);
      }
    };

    // if(user && user["custom:type"] == "ems") {
    //   menuItems.push({
    //     label: "Recommend Disposition",
    //     onClick: onRecommendDispositionButtonClick,
    //   })
    // }

    const onNotificationDisabled = async (notificationStatus: string) => {
      let uInfos = localStorage.getItem("userinfo");
      if (uInfos) {
        const userinformation = JSON.parse(uInfos);
        Mixpanel.track("web_reminder_notification_" + notificationStatus, {
          name: userinformation.username,
        });
      }
      if (rootStore.emsStore.getSelectedEmergency) {
        await MedicalEmergencyService.updateNotificationShow(
          rootStore.emsStore.getSelectedEmergency.id,
          notificationStatus
        );
        rootStore.emsStore.handlePageRefreshCount(
          rootStore.emsStore.getpageRefreshCount + 1
        );
        rootStore.medicalCardStore.setFlightStatusMenu();
      }
    };

    if (rootStore.emsStore.getSelectedEmergency) {
      if (user && user["custom:type"] == "ems") {
        let notificationHandler = {} as MenuItem;
        if (
          rootStore.emsStore.getSelectedEmergency.notificationShow == "on" ||
          (rootStore.emsStore.getSelectedEmergency.notificationShow == null &&
            rootStore.emsStore.getSelectedEmergency.status != "RESOLVED")
        ) {
          notificationHandler.label = "Disable Notification";
          notificationHandler.onClick = () => onNotificationDisabled("off");
        } else {
          notificationHandler.label = "Enable Notification";
          notificationHandler.onClick = () => onNotificationDisabled("on");
        }
        menuItems.push(notificationHandler);
      }
    }

    const menuListItem = menuItems.map((item) => {
      return <li onClick={item.onClick}>{item.label}</li>;
    });

    useEffect(() => {
      const observeBoxHeight = () => {
        if (!boxRef.current) return;

        const observer = new ResizeObserver((entries) => {
          for (let entry of entries) {
            const newHeight = entry.contentRect.height;
            props.cardHeight(newHeight);
          }
        });

        observer.observe(boxRef.current);

        return () => {
          observer.disconnect();
        };
      };

      observeBoxHeight();
    }, []);

    useEffect(() => {
      // Get passenger detail
      if (rootStore.emsStore.getSelectedEmergency) {
        (async () => {
          try {
            const response = await PassengerService.getAnswereById(rootStore.emsStore.getSelectedEmergency?.passengerId ?? 1, 3);
            rootStore.emsStore.handleCronicDieses(response[0].answer);
          } catch(error) {
            console.log("Error in get answer 1 in passenger detail.",error);
          }
        })();
    
        (async () => {
          try {
            const response = await PassengerService.getAnswereById(rootStore.emsStore.getSelectedEmergency?.passengerId ?? 1, 4);
            rootStore.emsStore.handlePhysicalDisableAns(response[0].answer);
          } catch (error) {
            console.log("Error in get answer 2 in passenger detail.",error);
          }
        })();
      }

      return () => {
        rootStore.medicalCardStore.resetFlightStatusMenu();
      }
  },[rootStore.emsStore.getSelectedEmergency]);


  // Handle outside click
  const actionListRef = useRef<HTMLDivElement>(null); // Explicitly type the ref as HTMLDivElement

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => { // Type event as MouseEvent
      if (
        actionListRef.current &&
        !actionListRef.current.contains(event.target as Node) && // Type assertion for event.target
        rootStore.medicalCardStore.getFlightStatusMenu
      ) {
        rootStore.medicalCardStore.setFlightStatusMenu(); // Toggle the menu off
      }
    };

    // Add event listener to document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Empty dependency array since we only need to set this up once

  // End Handle outside click

    return (
      <Box
        ref={boxRef}
        style={{ ...styles.container, ...props.containerStyle }}
        elevation="xsmall"
      >
        <Box direction="row" className="emergency-info-outer">
          <Box>
            <Box direction="row">
              <Box className="assigned-profile"></Box>
              <UserCardComponent
                username={props.passengerName}
                iconScale={1.2}
                userNameFontStyle={StandardFonts.h42021Semibold}
                subTextComponent={SubText}
                onlineIndicator2={props.online}
                isDetailScreen={props.detail}
              />
            </Box>
            <Box margin={"4px 0 0"}>
                <StatusChip borderR={18} status={props.status} showLabel={true}/>
            </Box>
            <Box margin={"4px 0 0"}>
                {props.diversion == "DIVERSION_REQUIRED" ? <RecommedDiversion /> : null}
            </Box>
          </Box>
          
          <Box style={styles.actionMenuMain}>
          <div style={{ fontSize: 18, fontWeight:'bold',}}>Update Status</div>
            <Box style={{ position: "relative" }}>
            
              <Box
                className={props.status == "RESOLVED" ? "disable-action" : ""}
                onClick={() => rootStore.medicalCardStore.setFlightStatusMenu()}
                style={{ ...styles.actionMenu,
                  height: '50px',
                  width: '50px' 
                }}
              >
                <img src={editIcon} style={{ width: 24 }}/>
              </Box>
              {rootStore.medicalCardStore.getFlightStatusMenu && (
                <div className="action-list-outer" ref={actionListRef}>
                  <ul className="action-list">{menuListItem}</ul>
                </div>
              )}
            </Box>
          </Box>
        </Box>
        <Box className="medical-card-container">
          <Box>
            {props.PatientConscious && <PatientConscious />}
            <div
              style={{
                marginBottom: diversion == "DIVERSION_REQUIRED" ? 0 : 14,
              }}
            >
              {/* {props.diversion == "DIVERSION_REQUIRED" && <RecommedDiversion />} */}
            </div>
            <Box className="patient-propert-container">
              <Box className="patient-property">
                <PropertyDisplayField
                  title="Age"
                  value={props.age}
                  symbol={age}
                />
              </Box>
              <Box className="patient-property">
                <PropertyDisplayField
                  title="Gender"
                  value={props.gender}
                  symbol={gender}
                />
              </Box>
              <Box className="patient-property">
                <PropertyDisplayField
                  title="Seat No."
                  value={props.seatNumber}
                  symbol={seatNo}
                />
              </Box>

              {/* New div for Plane Location icon and label */}
              <Box className="patient-property">
      <div className="plane-location-section" onClick={handlePlaneIconClick} style={{ marginLeft: '6px', cursor: 'pointer' }}>
        <FaPlane size={17} color="rgba(30, 108, 246, 0.8)" /> {/* Plane icon */}
        <span style={{fontSize: '14px', color: 'rgb(75, 98, 138)', marginLeft: '11px'}}>Plane Location</span> {/* Label */}
      </div>

      {/* Conditionally render the FlightLocationDemo component in a new div */}
      {showFlightLocation && (
        <div className="flight-location-container">
          <FlightLocationDemo />
        </div>
        )}
        </Box>
              {rootStore.medicalCardStore.getMedicalCardExpand && (
                <>
                  <Box className="patient-property">
                    <PropertyDisplayField
                      title="Physically Disable"
                      value={
                        rootStore.emsStore.getPhysicalDisableAns ?? "No Information Provided"
                      }
                      symbol={seatNo}
                    />
                  </Box>
                  <Box className="patient-property border-bottom">
                    <PropertyDisplayField
                      title="Chronic Disease"
                      value={
                        rootStore.emsStore.getCronicDiseases ?? "No Information Provided"
                      }
                      symbol={seatNo}
                    />
                  </Box>
                </>
              )}
            </Box>
            {rootStore.medicalCardStore.getMedicalCardExpand && (
              <>
                {/* {rootStore.emsStore.getSelectedEmergency &&
                rootStore.emsStore.getSelectedEmergency?.passengerId ? (
                  <PassengerMedicalHistory PassId={rootStore.emsStore.getSelectedEmergency?.passengerId} />
                ) : null} */}
                <Box style={styles.timeStampContainer}>
                  <Box>
                    {props.symptoms.length > 0 ? (
                      <>
                        <PropertyStatusField
                          style={styles.symptomListContainer}
                          title="Passenger complaints & observations"
                          valueComponent={renderChipList(props.symptoms)}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Box>
              </>
            )}
          </Box>
          <Box>
            <Box style={styles.timeflightcontainer}>
              {/* <div>
                <div style={styles.timestamp}>
                  {formatTimeStamp(props.time)}
                </div>
                <div style={styles.timestamp2}>{props.tailNo}</div>
              </div> */}
              <div className="medical-card-expand-container" style={{opacity: props.status == "RESOLVED" ? 0.6 : 1,cursor: props.status == "RESOLVED" ? 'not-allowed' : "pointer",pointerEvents: props.status == "RESOLVED" ? "none" : "auto",paddingBottom: 25}} onClick={() => rootStore.medicalCardStore.toggleMedicalCardExpand()}
              >
                <Text className="medical-card-know-more">{ rootStore.medicalCardStore.getMedicalCardExpand ? "Close" : "Know More" }</Text>
                <Box
                  className="medical-card-know-more-icon"
                  onMouseOver={() =>
                    rootStore.medicalCardStore.toggleMedicalCardExpandHover(
                      true
                    )
                  }
                  onMouseOut={() =>
                    rootStore.medicalCardStore.toggleMedicalCardExpandHover(
                      false
                    )
                  }
                >
                  {rootStore.medicalCardStore.getMedicalCardExpand ? (
                    <img
                      src={
                        rootStore.medicalCardStore.getMedicalCardExpandHover
                          ? minimize_hover_state
                          : minimize
                      }
                      alt="expand icon"
                    />
                  ) : (
                    <img
                      src={
                        rootStore.medicalCardStore.getMedicalCardExpandHover
                          ? expand_hover_state
                          : expand
                      }
                      alt="expand icon"
                    />
                  )}
                  {rootStore.medicalCardStore.getMedicalCardExpandHover && (
                    <div className="tooltip">
                      <Text className="tooltipTxt">
                        {rootStore.medicalCardStore.getMedicalCardExpand ? "Collapse" : "Expand"}
                      </Text>
                    </div>
                  )}
                </Box>
                {/* <Box
                  onMouseOver={expandHover}
                  onMouseOut={expandHover}
                  onClick={() => expandChat(type)}
                  className="controlBtn ml10"
                  style={styles.expandAreaBtn}
                >
                  {rootStore.emsStore.getExpand ? (
                    <img
                      src={isExpandHover ? minimize_hover_state : minimize}
                      alt="video call icon"
                    />
                  ) : (
                    <img
                      src={isExpandHover ? expand_hover_state : expand}
                      alt="video call icon"
                    />
                  )}
                  {true && (
                    <div className="tooltip">
                      <Text className="tooltipTxt">
                        {rootStore.emsStore.getExpand ? "Collapse" : "Expand"}
                      </Text>
                    </div>
                  )}
                </Box> */}
              </div>
            </Box>
            {props.footerComponent}
          </Box>
        </Box>
      </Box>
    );
  });

MedicalEmergencyCard.defaultProps = {
  passengerName: "John Doe",
  containerStyle: {},
  emsId: "ems",
  symptoms: [],
  treatmentsGiven: [],
  passengerStatusQuestions: [],
};

export default MedicalEmergencyCard;

const styles: StyleSheet = {
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: StandardColors.white,
    borderRadius: 16,
    justifyContent: "space-between",
    flex: 1,
  },
  middleOneSection: {
    marginTop: 16,
    marginLeft: 14,
    marginRight: 14,
    minHeight: "unset",
  },
  middleOneSection1: {
    marginLeft: 14,
    marginRight: 14,
    minHeight: "unset",
  },
  passengerStatusTitle: {
    marginBottom: 16,
    color: StandardColors.black_80,
    ...StandardFonts.h51624Medium,
  },
  symptomContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    minHeight: "unset",
    color: "#4b628a",
    fontFamily: "Inter",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "16px",
  },
  symptomListContainer: {
    marginTop: 0,
  },
  actionMenu: {
    display: "flex",
    width: 50,
    height: 50,
    padding: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 40,
    background: "#357EFF",
    marginLeft: 6,
    cursor: "pointer",
    boxShadow: "none",
  },
  actionMenuMain: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  timeStampContainer: {
    marginLeft: 14,
    marginRight: 14,
    marginTop: 14,
  },
  timeflightcontainer: {
    marginLeft: 14,
    marginRight: 14,
    marginBottom: 10,
    marginTop: 30,
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
  },
  timestamp: {
    color: "#A7B6D1",
    fontFamily: "Inter",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "12px",
  },
  timestamp2: {
    color: "#A7B6D1",
    fontFamily: "Inter",
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "12px",
    marginTop: 6,
  },
};
